import React, { useEffect, useState } from 'react'
import DashboardHeader from '../DashboardHeader/DashboardHeader'
import { BsArrowLeftShort, BsThreeDots } from 'react-icons/bs'
import { CopyIcon2, InfoIcon2, PencilIcon, ProductIcon } from '../../Assets/AllSvg'
import { Menu, MenuHandler, MenuItem, MenuList, Tooltip } from '@material-tailwind/react'
import ArchiveProductModal from '../ArchiveProductModal/ArchiveProductModal'
import { useNavigate, useLocation } from 'react-router'
import DeleteProductModal from '../DeleteProductModal/DeleteProductModal'
import { AiTwotoneDelete } from 'react-icons/ai'
import { BiPlus } from 'react-icons/bi'
import AddPriceModal from '../AddPriceModal/AddPriceModal'
import { IoClose } from 'react-icons/io5'
import AddProductModal from '../AddProductModal/AddProductModal'
import { GetProductByID } from '../API/ProductAPI'
import { GetPrice } from '../API/PriceAPI'
import moment from 'moment'
import AWS from 'aws-sdk';
import { toast } from 'react-toastify'

const S3_BUCKET = process.env.REACT_APP_IMAGE_S3_BUCKET;
const APP_ACCESS_KEY = process.env.REACT_APP_ACCESS_KEY;
const APP_SCRET_KEY = process.env.REACT_APP_SCRET_KEY;

const ProductDetail = () => {
    const [active, setActive] = useState(false)
    const [delProduct, setDelProduct] = useState(false)
    const [addPrice, setAddPrice] = useState(false)
    const [sendData, setSendData] = useState('')
    const [addNew, setAddNew] = useState(false)
    const [editPrice, setEditPrice] = useState('')
    const [options, setOptions] = useState({
        metaData: false
    })
    const [cusField, setCusField] = useState({
        field: false,
        value: ''
    })
    const [productInfo, setProductInfo] = useState('')
    const [deleteProduct, setDeleteProduct] = useState('')
    const [prodDel, setProdDel] = useState(false)
    const [metadataList, setMetadataList] = useState([])
    const [finalMetadata, setFinalMetadata] = useState([])
    const [priceList, setPriceList] = useState([])
    const [file, setFile] = useState('');

    const navigate = useNavigate()
    const location = useLocation()
    const ID = location.pathname.split('/').pop()

    const handleOpenArchive = () => {
        setActive(!active)
        setSendData('product')
    }

    const handleOpenArchivePrice = () => {
        setActive(!active)
        setSendData('price')
    }

    const handleOpenDelProduct = () => {
        setDelProduct(true)
        setSendData('product')
        setDeleteProduct(productInfo)
    }

    const handleOpenDelPrice = (val) => {
        setDelProduct(true)
        setSendData('price')
        setDeleteProduct(val)
    }

    const handleEditMetadata = () => {
        setOptions({ ...options, metaData: !options.metaData })
        setMetadataList([...metadataList, {key : '', value: ''}])
        if(metadataList.length !== 0){
            setMetadataList(finalMetadata)
            setFinalMetadata([])
        }
    }
    
    const handleSaveMetadata = () => {
        setFinalMetadata(metadataList)
        setOptions({ ...options, metaData: false })
    }

    const handleCancleMetadata = () => {
        setFinalMetadata(metadataList)
        setOptions({ ...options, metaData: !options.metaData })
    }

    const handleOnchangeKey = (e, i) => {
        const data = metadataList.map((val, ind) => {
            if(ind === i){
                val.key = e.target.value
            }
            return val
        })
        setMetadataList(data)
    }

    const handleOnchangeValue = (e, i) => {
        const data = metadataList.map((val, ind) => {
            if(ind === i){
                val.value = e.target.value
            }
            return val
        })
        setMetadataList(data)
    }

    const handleAddNew = () => {
        setCusField({ ...cusField, field: false, value: 'add' })
        setAddNew(true)
    }

    const handleAddCus = () => {
        setCusField({ ...cusField, field: false, value: 'product' })
    }

    const handleRemoveItem = () => {
        setCusField({ ...cusField, field: false, value: '' })
    }

    const handleNavigatePrice = (id) => {
        navigate(`/product/price-detail/${ id }`, {state:{data:productInfo.name}})
    }

    const getProductDetails = async () => {
        if(!delProduct && !addPrice){
            const result = await GetProductByID(ID)
            setProductInfo(result)

            const price = await GetPrice()
            setPriceList(price)

            //Get image from AWS s3
            AWS.config.update({
                accessKeyId: APP_ACCESS_KEY,
                secretAccessKey: APP_SCRET_KEY,
                region: process.env.REACT_APP_REGION,
            });
        
            const s3 = new AWS.S3();
            const params = {
                Bucket: S3_BUCKET,
                Prefix: `${result.user_id}/${result.product_id}/`,
            };
        
            s3.listObjectsV2(params, (err, data) => {
                if (err) {
                    toast.error(err, { autoClose: 5000 });
                } else {
                    const urls = data.Contents.map((object) => {
                        return `https://${S3_BUCKET}.s3.${AWS.config.region}.amazonaws.com/${object.Key}`;
                    });
                    urls[0] ? setFile(urls[0]) : setFile('')
                }
            });
        }
    }

    const getPrice = (productId) => {
        const data = priceList.filter((val) => val.product_id === productId)
        if(data.length !== 0){
            if(data.length > 1){
                return `${data.length} prices`
            } else {
                const billing = data[0].billing_period ? data[0].billing_period : 'month'
                const finalStr = `$${data[0].price_data}.00 ${data[0].select_currency} / ${billing}`
                return  finalStr
            }
        }
    }

    useEffect(() => {
      getProductDetails()
    }, [delProduct, addPrice])

    return (
        <>
            <div>
                <DashboardHeader />
                <div className="max-w-[1690px] mx-auto sm:p-[40px] p-[20px] w-full text-[#414552]">
                    <div className="flex items-center justify-between">
                        <div className='flex items-center gap-1 text-[#687385] text-sm cursor-pointer' onClick={() => navigate('/product')}>
                            <button><BsArrowLeftShort className='text-[22px]' /></button>
                            <span className='font-medium'>PRODUCTS</span>
                        </div>
                        <Tooltip className="bg-gray-800 text-white" content={
                            <div className='flex items-center text-sm gap-1 rounded-sm'>Copy ID <div className="ml-1 flex gap-1 items-center p-[1px_6px] rounded-sm bg-gray-700 text-xs font-normal">ctrl</div>+<div className="ml-1 flex gap-1 items-center p-[1px_6px] rounded-sm bg-gray-700 text-xs font-normal">i</div></div>
                        }>
                            <button className='text-xs text-[#687385] flex items-center gap-1'>prod_O2NtrSnO6Tpf91 <CopyIcon2 className="fill-[#687385]" /></button>
                        </Tooltip>
                    </div>
                    <div className="flex items-center justify-between mt-5 sm:pb-7 pb-2 border-b-[1px] border-[#ebeef1]">
                        <div className="flex xs:gap-4 gap-2 items-center">
                            <div className='w-max p-[8px] rounded-md shadow-[0_0_0_1px_rgb(235,238,241)] bg-[#f7fafc80]'>
                                {file 
                                    ? <img src={file} alt='' className='w-[40px] h-[40px] object-contain' />
                                    : <ProductIcon className="fill-gray-400 sm:w-[16px] w-[12px] sm:h-[16px] h-[12px]" />
                                }
                            </div>
                            <div>
                                <h3 className='text-[#1a1b25] sm:text-[20px] font-medium xs:font-normal text-[16px]'>{productInfo.name}</h3>
                                <p className='text-[#687385] text-sm'>{getPrice(ID)}</p>
                            </div>
                        </div>
                        <div className="flex items-center xs:gap-4 gap-2">
                            <Tooltip placement="top" className="bg-white text-[#414552] shadow-[0px_0px_10px_1px_rgba(0,0,0,0.15)] text-sm text-start p-[20px] w-full max-w-[300px]" content={
                                <div className='text-sm text-[#414552]'>
                                    Please <span className='text-[#625afa] font-medium'> activate your account </span>to access live data
                                </div>
                            }>
                                <button className="opacity-60 input_focus_shadow h-[28px] text-[#414552] rounded-[6px] text-[12px] xs:text-[14px] font-semibold p-[0_8px]">Copy to live mode</button>
                            </Tooltip>
                            <Menu placement="bottom-end">
                                <MenuHandler>
                                    <button className='px-2 py-1 hover:bg-white rounded-md'><BsThreeDots /></button>
                                </MenuHandler>
                                <MenuList className='px-0 py-2 mt-2 min-w-[168px] outline-remove'>
                                    <MenuItem onClick={() => navigate(`/product/edit?id:${ID}`)} className='text-sm font-medium text-[#625afa] px-[12px] py-1 rounded-none'>Edit product</MenuItem>
                                    <hr className='my-1' />
                                    <MenuItem onClick={handleOpenArchive} className='text-sm font-medium text-[#625afa] px-[12px] py-1 rounded-none'>Archive product</MenuItem>
                                    <MenuItem onClick={handleOpenDelProduct} className='text-sm font-medium text-[#df1b41] px-[12px] py-1 rounded-none'>Delete Product</MenuItem>
                                </MenuList>
                            </Menu>
                        </div>
                    </div>
                    <div className='flex my-[16px]'>
                        <div className='pr-4 border-r-[1px] border-[#ebeef1] text-sm'>
                            <h3 className='text-[#687385]'>Updated</h3>
                            <p className='text-[#414552]'>{moment(productInfo.inserted_dt).format("MMMM DD, yyyy")}</p>
                        </div>
                        <div className='pl-4 border-l-[1px] border-[#ebeef1] text-sm'>
                            <div className='text-[#687385] flex items-center gap-2'>MRR
                                <Tooltip placement="right" className="bg-white text-[#414552] shadow-[0px_0px_10px_1px_rgba(0,0,0,0.15)] text-sm text-start p-[10px] w-max" content={
                                    <div className='text-sm text-[#414552]'>
                                        Data as of {moment(productInfo.inserted_dt).format("MMMM DD")}
                                    </div>
                                }>
                                    <button><InfoIcon2 /></button>
                                </Tooltip>
                            </div>
                            <p className='text-[#414552]'>{getPrice(ID)}</p>
                        </div>
                    </div>
                    <div className="mt-12">
                        <div className="pb-3 border-b-[1px] border-[#ebeef1] flex justify-between items-center">
                            <span className="text-[#30313d] text-[20px] font-bold">Customer</span>
                            <button onClick={() => navigate(`/product/edit?id:${ID}`)} className='h-[30px] rounded-[6px] input_focus_shadow text-[14px] font-semibold p-[0_8px] flex items-center gap-2'><PencilIcon />Edit</button>
                        </div>
                        <div className="grid sm:grid-cols-2 grid-cols-1 mt-4 gap-4">
                            <div className='font-medium'>
                                <div className='flex text-sm'>
                                    <div className='text-[#687385] max-w-[240px] w-full'>Name</div>
                                    <span className='text-[#414552]'>{productInfo.name}</span>
                                </div>
                                <div className='flex text-sm mt-2'>
                                    <div className='text-[#687385] max-w-[240px] w-full'>Created</div>
                                    <span className='text-[#414552]'>{moment(productInfo.inserted_dt).format("MMMM DD")}</span>
                                </div>
                                <div className='flex text-sm mt-2'>
                                    <div className='text-[#687385] max-w-[240px] w-full'>Statement descriptor</div>
                                    <span className='text-[#a3acba]'>{productInfo.statement_descriptor}</span>
                                </div>
                                <div className='flex text-sm mt-2'>
                                    <div className='text-[#687385] max-w-[240px] w-full'>Feature list</div>
                                    <span className='text-[#a3acba]'>{productInfo.feature_list}</span>
                                </div>
                            </div>
                            <div className='flex text-sm font-medium gap-4 items-start'>
                                <div className='text-[#687385]'>Image</div>
                                {file 
                                    ? <div><img src={file} alt='' className='w-[108px] rounded-[4px] object-contain'/></div>
                                    : <span className='text-[#a3acba] ml-5'>No image</span>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="mt-12">
                        <div className="pb-3 border-b-[1px] border-[#ebeef1] flex justify-between items-center">
                            <span className="text-[#30313d] text-[20px] font-bold">Pricing</span>
                            <button onClick={() => setAddPrice(true)} className="h-[30px] rounded-[6px] input_focus_shadow text-[14px] font-semibold p-[0_8px] flex items-center gap-2"><BiPlus className='text-[18px]' />Add another price</button>
                        </div>
                        <div className='w-full overflow-x-auto'>
                            <table className='md:w-full w-[740px] overflow-x-auto'>
                                <thead>
                                    <tr className='border-b-[1px] border-[#ebeef1] text-[#1a1b25] text-[11px]'>
                                        <th className='px-[12px] py-[8px] font-medium text-start md:w-[300px] w-[150px] block'>PRICE</th>
                                        <th className='px-[12px] py-[8px] font-medium text-start w-full'>API ID</th>
                                        <th className='px-[12px] py-[8px] font-medium text-start'>CREATED</th>
                                        <th className='px-[12px] py-[8px] font-medium text-start'></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {priceList.map((val) =>
                                    val.product_id === ID &&
                                        <tr key={val.price_id} className='border-b-[1px] border-[#ebeef1] hover:bg-[#f6f8fa]'>
                                            <td className='px-[8px] py-[16px] font-medium text-sm text-[#1a1b25] cursor-pointer' onClick={() => handleNavigatePrice(val.price_id)}>${val.price_data} {val.select_currency}</td>
                                            <td className='px-[8px] py-[16px] cursor-pointer' onClick={() => handleNavigatePrice(val.price_id)}>
                                                <div className='flex items-center gap-2'>
                                                    <input className='w-max input_focus_shadow p-[4px_8px] text-[11px] font-medium rounded-md' value={val.price_id} />
                                                    <Tooltip className="bg-gray-800 text-white" placement="right" content={
                                                        <div className='flex items-center text-xs gap-1 rounded-sm'>Copy to clipboard</div>
                                                    }>
                                                        <button className='bg-white rounded-md input_focus_shadow p-[6px_8px]'><CopyIcon2 className="fill-[#414552] w-[12px] h-[12px]" /></button>
                                                    </Tooltip>
                                                </div>
                                            </td>
                                            <td className='px-[8px] py-[16px] cursor-pointer text-center text-sm text-[#1a1b25]' onClick={() => handleNavigatePrice(val.price_id)}>{moment(val.inserted_dt).format("MMMM DD")}</td>
                                            <td className='px-[12px] py-[16px] text-sm pl-[50px] relative z-50'>
                                                <Menu placement="bottom-end">
                                                    <MenuHandler>
                                                        <button className='px-2 py-1 hover:bg-white rounded-md'><BsThreeDots /></button>
                                                    </MenuHandler>
                                                    <MenuList className='px-0 py-2 mt-2 min-w-[168px] outline-remove'>
                                                        <div className='text-[#687385] text-xs font-medium px-[12px] py-1'>PRICING</div>
                                                        <MenuItem onClick={() => {setAddPrice(true); setEditPrice(val)}} className='text-sm font-medium text-[#625afa] px-[12px] py-1 rounded-none'>Edit price</MenuItem>
                                                        <MenuItem onClick={handleOpenArchivePrice} className='text-sm font-medium text-[#625afa] px-[12px] py-1 rounded-none'>Archive price</MenuItem>
                                                        <MenuItem onClick={() => handleOpenDelPrice(val)} className='text-sm font-medium text-[#df1b41] px-[12px] py-1 rounded-none'>Delete price</MenuItem>
                                                    </MenuList>
                                                </Menu>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="mt-12">
                        <div className="pb-3 border-b-[1px] border-[#ebeef1] flex gap-3 items-center">
                            <span className="text-[#30313d] text-[20px] font-bold">Cross-sells</span>
                            <Tooltip placement="top-center" className="bg-white text-[#414552] shadow-[0px_0px_10px_1px_rgba(0,0,0,0.15)] text-sm text-start p-[20px] w-full max-w-[300px]" content={
                                <div className='text-sm'>
                                    Increase your average order value by allowing customers to add a related product to their order. <br /><span className='text-[#625afa] font-semibold'>Learn more</span>
                                </div>
                            }>
                                <div className='flex gap-1 items-center text-xs font-medium rounded-md text-[#545969] bg-[#ebeef1] p-[1px_6px]'>Boost revenue<InfoIcon2 /></div>
                            </Tooltip>
                        </div>
                        <div className='flex xs:flex-row flex-col items-center mt-3 gap-2'>
                            <h3 className='text-sm text-[#697385] sm:w-[270px] w-max whitespace-nowrap'>Cross-sells to</h3>
                            <div className='w-full flex items-start gap-4'>
                                <div className='w-full sm:w-max'>
                                    {cusField.value === "product" &&
                                        <div className='w-max flex gap-3 text-sm items-start'>
                                            <div className='w-max p-[12px] rounded-md shadow-[0_0_0_1px_rgb(235,238,241)] bg-[#f7fafc80]'><ProductIcon className="fill-gray-400 w-[14px] h-[16px]" /></div>
                                            <div>
                                                <h3 className='text-[#1a1b25] font-medium'>test</h3>
                                                <p className='text-[#687385]'>$0.00 USD</p>
                                            </div>
                                            <button onClick={handleRemoveItem} className='ml-3'><IoClose className='text-[16px] text-gray-600' /></button>
                                        </div>
                                    }
                                    {cusField.value !== "product" &&
                                        <div className='relative sm:w-[350px] w-full z-0'>
                                            {cusField.field &&
                                                <div className='fixed z-0 top-0 left-0 h-full w-full' onClick={() => setCusField({ ...cusField, field: false })}></div>
                                            }
                                            <input type="text" className='input_focus_shadow text-[#404552] relative z-10 font-normal px-2 w-full bg-white rounded-[6px] focus:outline-none h-[30px] text-[14px]' placeholder='Find a product…' onFocus={() => setCusField({ ...cusField, field: true })} />
                                            {cusField.field &&
                                                <div className='absolute z-10 mt-2 max-h-72 w-full overflow-auto rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 px-1 focus:outline-none text-sm'>
                                                    <button className='px-[7px] w-full font-semibold rounded-[4px] py-1
                                                     hover:bg-[#625afa] hover:text-white text-[#414552] flex items-center gap-2' onClick={handleAddNew}>
                                                        <BiPlus className='text-[20px]' /> Add new product
                                                    </button>
                                                    <button className='px-[7px] w-full font-normal rounded-[4px] group py-1
                                                     hover:bg-[#625afa] hover:text-white text-[#687385] flex items-center justify-between gap-2' onClick={handleAddCus}>
                                                        <span className='text-[#414552] group-hover:text-white flex gap-2 font-semibold'><ProductIcon className="fill-gray-600 group-hover:fill-white w-[12px] translate-y-[2px]" /> Bhavin sen</span>
                                                        <h3 className='text-[#414552] group-hover:text-white'>$0.00 USD</h3>
                                                    </button>
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>
                                <Tooltip placement="top-center" className="bg-white text-[#414552] shadow-[0px_0px_10px_1px_rgba(0,0,0,0.15)] text-sm text-start p-[20px] w-full max-w-[300px]" content={
                                    <>
                                        <p className='text-sm'>Suggest a related product for customers to add to their order, right in Checkout.</p>
                                        <div className='text-sm mt-5'>
                                            Off-session card payments are not supported via the Dashboard. <br /><span className='text-[#625afa]'>Learn more →</span>
                                        </div>
                                    </>
                                }>
                                    <button><InfoIcon2 /></button>
                                </Tooltip>
                            </div>
                        </div>
                    </div>
                    <div className="mt-12">
                        <div className="pb-3 border-b-[1px] border-[#ebeef1] flex justify-between items-center">
                            <span className="text-[#30313d] text-[20px] font-bold">Metadata</span>
                            <button onClick={handleEditMetadata} disabled={options.metaData ? true : false} className={`${options.metaData && "opacity-60 "} h-[30px] rounded-[6px] input_focus_shadow text-[14px] font-semibold p-[0_8px] flex items-center gap-2`}><PencilIcon />Edit metadata</button>
                        </div>
                        {finalMetadata.length === 0 ? 
                            <div className='mt-3'>
                                {options.metaData ?
                                    <div>
                                        <>
                                            {metadataList.map((val, ind) => 
                                                <div className="w-full flex gap-3 pb-5 border-b-[1px] border-[#ebeef1]">
                                                    <input
                                                        value={val.key}
                                                        onChange={(e) => handleOnchangeKey(e, ind)}
                                                        type="text" placeholder="Key"
                                                        className="input_focus_shadow max-w-[175px] text-[#404552] font-normal px-2 w-full bg-white rounded-[6px] focus:outline-none h-[30px] text-[14px]"
                                                    />
                                                    <textarea
                                                        value={val.value}
                                                        onChange={(e) => handleOnchangeValue(e, ind)}
                                                        placeholder="Value"
                                                        className="input_focus_shadow py-1 text-[#404552] font-normal px-2 w-full bg-white rounded-[6px] focus:outline-none h-[30px] text-[14px]"
                                                    />
                                                    <button onClick={() => setMetadataList(metadataList.filter((value, i) => i !== ind))}>
                                                        <AiTwotoneDelete className="text-[18px] text-[#625afa]" />
                                                    </button>
                                                </div>
                                            )}
                                            <div className='flex justify-between items-center'>
                                                <button onClick={() => setMetadataList([...metadataList, {key : '', value: ''}])} className="sm:mt-4 sm:ml-3 flex items-center gap-1 text-sm font-semibold text-[#625afa]"><BiPlus className='text-[18px]' /> Add custom field</button>
                                                <div className="font-semibold sm:p-[16px_20px] p-[16px_0_16px_0] flex text-base text-gray-900 gap-2">
                                                    <button onClick={handleCancleMetadata} className="border-[2px] h-[30px] rounded-[6px] border-[#ebeef1] text-[14px] font-semibold p-[0_8px]">Cancel</button>
                                                    <button onClick={handleSaveMetadata} className="border-[2px] h-[30px] rounded-[6px] border-[#625afa] text-white bg-[#625afa] text-[14px] font-semibold p-[0_8px]">Save</button>
                                                </div>
                                            </div>
                                        </>
                                        
                                    </div> : <p className='text-sm text-[#a3acba]'> No metadata</p>
                                }
                            </div>
                            : finalMetadata.map((val) => (
                                <div className="flex justify-between border-b-[1px] border-[#ebeef1] items-center p-[9px_4px] hover:bg-[#f6f8fa] cursor-pointer">
                                    <div className="flex items-center gap-6">
                                        <h3 className='text-sm text-[#697385] sm:w-[270px] w-max whitespace-nowrap'>{val.key}</h3>
                                        <div>
                                            <h3 className='text-sm text-[#697385] sm:w-[270px] w-max whitespace-nowrap'>{val.value}</h3>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                    <div className="mt-12">
                        <div>
                            <div className="flex justify-between py-[12px]">
                                <span className="text-[#1a1b25] text-[20px] font-bold">Logs</span>
                            </div>
                            <div className='w-full overflow-x-auto'>
                                <div className='sm:w-full w-[610px] overflow-x-auto'>
                                    <div className="flex justify-between border-t-[1px] border-[#ebeef1] items-center p-[9px_4px] hover:bg-[#f6f8fa] cursor-pointer">
                                        <div className="flex items-center gap-6">
                                            <div className="bg-[#ebeef1] text-[#545969] p-[1px_6px] rounded-[4px] text-xs font-semibold">200 OK</div>
                                            <div>
                                                <code className="text-[13px] text-[#585969]">POST /v1/products/prod_O2NtrSnO6Tpf91</code>
                                            </div>
                                        </div>
                                        <span className="text-[#687385] text-sm">6/12/23, 4:38:50 PM</span>
                                    </div>
                                    <div className="flex justify-between border-t-[1px] border-[#ebeef1] items-center p-[9px_4px] hover:bg-[#f6f8fa] cursor-pointer">
                                        <div className="flex items-center gap-6">
                                            <div className="bg-[#fcedb9] text-[#a82c00] p-[1px_6px] rounded-[4px] text-xs font-semibold">401 ERR</div>
                                            <div>
                                                <code className="text-[13px] text-[#585969]">POST /v1/products/prod_O2NtrSnO6Tpf91</code>
                                            </div>
                                        </div>
                                        <span className="text-[#687385] text-sm">6/12/23, 4:38:50 PM</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-12">
                        <div>
                            <div className="flex justify-between py-[12px]">
                                <span className="text-[#1a1b25] text-[20px] font-bold">Events</span>
                            </div>
                            <div className='w-full overflow-x-auto'>
                                <div className='sm:w-full w-[610px] overflow-x-auto'>
                                    <div className="flex justify-between border-t-[1px] border-[#ebeef1] items-center p-[9px_4px] hover:bg-[#f6f8fa] cursor-pointer">
                                        <div className="flex items-center gap-6">
                                            <div>
                                                <span className="text-[13px] text-[#585969]">A product with ID prod_O2NtrSnO6Tpf91 was updated</span>
                                            </div>
                                        </div>
                                        <span className="text-[#687385] text-sm">6/12/23, 4:38:50 PM</span>
                                    </div>
                                    <div className="flex justify-between border-t-[1px] border-[#ebeef1] items-center p-[9px_4px] hover:bg-[#f6f8fa] cursor-pointer">
                                        <div className="flex items-center gap-6">
                                            <div>
                                                <span className="text-[13px] text-[#585969]">A product with ID prod_O2NtrSnO6Tpf91 was updated</span>
                                            </div>
                                        </div>
                                        <span className="text-[#687385] text-sm">6/12/23, 4:38:50 PM</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ArchiveProductModal active={active} setActive={setActive} sendData={sendData} />
            <DeleteProductModal
                delProduct={delProduct}
                setDelProduct={setDelProduct}
                sendData={sendData}
                deleteProduct={deleteProduct}
                setDeleteProduct={setDeleteProduct}
                prodDel={prodDel}
                setProdDel={setProdDel}
            />
            <AddPriceModal addPrice={addPrice} setAddPrice={setAddPrice} editPrice={editPrice} setEditPrice={setEditPrice} ID={ID} />
            <AddProductModal addNew={addNew} setAddNew={setAddNew} />
        </>
    )
}

export default ProductDetail